export default __webpack_public_path__ + "static/media/unknown-token.b3210b1c.png";